import { gql } from '@apollo/client';

/**
 * Fetches plan features including add-on pricing.
 * Public query (no auth required).
 * add_ons is a JSONObject with structure:
 *   add_ons[key].price[currency][billingCycle].price
 *   e.g. add_ons['aericast'].price['usd']['monthly'].price = 20
 */
export const PLAN_FEATURES_QUERY = gql`
  query PlanFeatures($query: PlanFeatureInput) {
    planFeatures(first: 1, query: $query) {
      page {
        edges {
          node {
            _id
            alias
            add_ons
          }
        }
      }
    }
  }
`;
